<script>
import { mapGetters } from 'vuex';
import { cleanLabelTitle } from 'dashboard/helper/commons.js';
import FilterChip from './FilterChip.vue';

export default {
  name: 'ReportsFiltersLabels',
  components: { FilterChip },
  emits: ['labelsFilterSelection'],
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    ...mapGetters({
      options: 'labels/getLabels',
    }),
  },
  mounted() {
    this.$store.dispatch('labels/get');
  },
  methods: {
    cleanLabelTitle,
    handleInput() {
      this.$emit('labelsFilterSelection', this.selectedOption);
    },
  },
};
</script>

<template>
  <FilterChip
    v-model="selectedOption"
    :options="options"
    track-key="id"
    :label-of="cleanLabelTitle"
    :color-of="option => option.color"
    :placeholder="$t('LABEL_REPORTS.FILTER_DROPDOWN_LABEL')"
    icon="i-lucide-tag"
    @update:model-value="handleInput"
  />
</template>
